import React from 'react'

import Loader from './Loader'

export const AsyncComponent: React.FC = ({ children }) => {
  return <React.Suspense fallback={<Loader fullPage={true} />}>{children}</React.Suspense>
}

export default AsyncComponent
